module.exports = {
    
    id: "https://ohstem.vn/lp-courses/lap-trinh-stem/lap-trinh-ket-noi-voi-yolobit/",
    title: "Lập Trình Kết Nối cùng Yolo:Bit",
    detail:
      'Trong phần này chúng ta sẽ cùng nhau tìm hiểu về khả năng kết nối của Yolo:Bit thông qua các nhóm khối lệnh WIFI và CHÂN CẮM.',
    image: "/assets/tutorials/courses/ketnoi.jpg",
    categoryIds: ["courses"],
    //label: "Mới bắt đầu?",
    labelClass: "green ribbon huge",
    toolbox: [
      {
        category: "basic",
        blocks: ["yolobit_basic_scroll_text", "yolobit_basic_forever"]
      }
    ],
    steps: [
      {
       
      }
    ]
  };
  